export const MANUFACTURING_VENDOR_CODES = {
    DIGIKEY: { value: "DIGIKEY", text: "디지키" },
    MOUSER: { value: "MOUSER", text: "마우저" },
};

export const MANUFACTURING_VENDOR_CURRENCIES = {
    KRW: { value: "KRW", text: "원화", prefix: "₩", suffix: "원" },
    USD: { value: "USD", text: "달러화", prefix: "$", suffix: "달러" },
};
